import type { RouteComponentProps } from '@reach/router';
// import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ListItem, ListItemContainer } from '@components/ListItem';
import MainTitle from '@components/MainTitle';
import FeedbackDialogListener from '@components/Modal/Content/FeedbackModalContent/FormDialog';

import {
  VITALL_ABOUT,
  VITALL_HELP,
  VITALL_PRIVACY,
  VITALL_TERMS,
} from '@constants/external-links';

// import * as ROUTES from '@constants/routes';
import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import { FeedbackEmailType } from 'generated/types';

const messages = defineMessages({
  mfa: {
    id: 'GLOBAL.mfa',
    defaultMessage: 'Multi-Factor Authentication',
  },
  notifications: {
    id: 'settings.notifications',
    defaultMessage: 'Notifications',
  },
  about: {
    id: 'settings.about',
    defaultMessage: 'About VITALL',
  },
  sendFeedback: {
    id: 'settings.sendFeedback',
    defaultMessage: 'Send Feedback',
  },
  helpAndSupport: {
    id: 'settings.helpAndSupport',
    defaultMessage: 'Help and Support',
  },
  title: {
    id: 'settings.title',
    defaultMessage: 'App Information',
  },
  privacy: {
    id: 'settings.privacy',
    defaultMessage: 'Privacy Notice',
  },
  toc: {
    id: 'settings.toc',
    defaultMessage: 'Terms and Conditions',
  },
  infoRequest: {
    id: 'settings.informationRequest',
    defaultMessage: 'Information Request',
  },
});

const SettingsPage: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <AppLayout friendlyName={formatMessage(messages.title)} showHeader>
      <MainContainer maxWidth="600px">
        <MainTitle title={formatMessage(messages.title)} />

        <ListItemContainer>
          {/* <ListItem
            title={formatMessage(messages.notifications)}
            onClick={() => { navigate(ROUTES.NOTIFICATION_SETTINGS) }}
          /> */}

          <ListItem
            onClick={() => window.open(VITALL_ABOUT, '_blank')}
            title={formatMessage(messages.about)}
          />

          <ListItem
            onClick={() => window.open(VITALL_HELP, '_blank')}
            title={formatMessage(messages.helpAndSupport)}
          />

          <FeedbackDialogListener type={FeedbackEmailType.Client_Feedback}>
            {({ handleOpen }) => (
              <ListItem
                onClick={handleOpen}
                title={formatMessage(messages.sendFeedback)}
              />
            )}
          </FeedbackDialogListener>

          <FeedbackDialogListener type={FeedbackEmailType.Information_Request}>
            {({ handleOpen }) => (
              <ListItem
                onClick={handleOpen}
                title={formatMessage(messages.infoRequest)}
              />
            )}
          </FeedbackDialogListener>

          {/* <ListItem
            onClick={() => {
              navigate(ROUTES.SETTINGS_MFA);
            }}
            title={formatMessage(messages.mfa)}
          /> */}

          <ListItem
            onClick={() => window.open(VITALL_TERMS, '_blank')}
            title={formatMessage(messages.toc)}
          />
          <ListItem
            onClick={() => window.open(VITALL_PRIVACY, '_blank')}
            title={formatMessage(messages.privacy)}
          />
        </ListItemContainer>
      </MainContainer>
    </AppLayout>
  );
};

export default SettingsPage;
